<div class="patient-retrieve-files-container">
  <h2>Patient Retrieve Files</h2>
  <p>This component is for retrieving patient files.</p>
</div>
